import {
  getRoleDatas,
  changeRoleStatus,
  getPermissionDatas,
  updatePermissionDatas,
  addRoleName,
  delRole,
  editRole
} from '@/services/role'
import i18n from '@/lib/language'
export default {
  namespaced: true,
  state: {
    loadingContent: true, // 加载动画
    roleDataList: [], // 角色列表数据
    roleDrawerVisible: false, // 角色管理抽屉面板状态
    addRoleDrawerVisible: false, // 新增角色抽屉面板状态
    permissionList: [], // 管理面板权限列表
    rolemanageLoading: false, // 保存loading
    roleManageDesc: {
      100000: i18n.t('message["1286"]'),
      100001: i18n.t('message["1495"]'),
      100002: '',
      100003: '',
      100004: ''
    },
    showNotification: false, // 是否提示信息查重设置
    initLoading: false
  },
  mutations: {
    setRolemanageLoading (state, data) {
      state.rolemanageLoading = data
    },
    setRoleDataList (state, data) {
      state.roleDataList = data
    },
    setRoleDrawerVisible (state, data) {
      state.roleDrawerVisible = data
    },
    setPermissionList (state, data) {
      state.permissionList = data
    },
    setLoadingContent (state, data) {
      state.loadingContent = data
    },
    setShowNotification (state, status) {
      state.showNotification = status
    },
    SET_ADD_ROLE_VISIBLE (state, type) {
      state.addRoleDrawerVisible = type
    },
    DEL_ROLE_LIST (state, id) {
      state.roleDataList = state.roleDataList.filter(item => item.roleid !== id)
    },
    SET_INIT_LOADING (state, load) {
      state.initLoading = load
    }
  },
  actions: {
    changeRoleManageVisible ({ commit }, type) {
      commit('setRoleDrawerVisible', type)
    },
    // 获取角色数据方法
    async fetchGetRoleDatas ({ commit, state }, params) {
      commit('setLoadingContent', true)
      const chain = await getRoleDatas()
        .onSuccess(payload => {
          commit('setLoadingContent', false)
          commit('setRoleDataList', payload)
          commit('SET_INIT_LOADING', true)
        })
        .params(params)
        .config({
          tip: false
        })
      return chain
    },
    async fetchGetRoleDatas2 ({ commit, state }, params) {
      commit('setLoadingContent', true)
      const chain = await getRoleDatas()
        .onSuccess(payload => {
          commit('setLoadingContent', false)
          commit('setRoleDataList', payload)
          commit('SET_INIT_LOADING', true)
        })
        .params(params)
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 设置权限状态
    async fetchChangeRoleStatus ({ dispatch }, roleid) {
      const chain = await changeRoleStatus()
        .onNetSuccess(raw => {
          dispatch('fetchGetRoleDatas2')
        })
        .params({
          roleid
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    },
    // 设置权限状态
    async fetchGetPermissionDatas ({ commit }, params) {
      commit('setLoadingContent', true)
      const chain = await getPermissionDatas()
        .onSuccess(payload => {
          // console.log(payload)
          commit('setLoadingContent', false)
          commit('setPermissionList', payload)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 设置权限状态
    async fetchUpdatePermissionDatas ({ commit }, params) {
      commit('setRolemanageLoading', true)
      const chain = await updatePermissionDatas()
        .onSuccess(payload => {
          const { repeatState } = payload
          if (!repeatState) {
            const INFO_REPEAT_INDEX = 3
            let isSelectedRepeat = params.permission.includes(INFO_REPEAT_INDEX)
            if (isSelectedRepeat) {
              commit('setShowNotification', true)
            }
          }
          commit('setRoleDrawerVisible', false)
          commit('setRolemanageLoading', false)
        })
        .params({
          ...params
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    },
    // 新增角色
    async fetchAddRole ({ commit, dispatch }, params) {
      commit('setRolemanageLoading', true)
      const { permission } = params
      const chain = await addRoleName()
        .params(params)
        .onSuccess((payload) => {
          const { roleid } = payload
          if (roleid) {
            dispatch('fetchUpdatePermissionDatas', { roleid, permission })
            dispatch('fetchGetRoleDatas2')
            commit('setRoleDrawerVisible', false)
          }
        })
        .onComplete(() => {
          commit('setRolemanageLoading', false)
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    },
    // 删除角色
    async fetchDeleteRole ({ commit }, params) {
      const chain = await delRole()
        .params(params)
        .config({
          tip: true,
          selfTip: true
        })
      return chain
    },
    // 编辑角色名称
    async fetchEditRole ({ commit, dispatch }, params) {
      commit('setRolemanageLoading', true)
      const { roleid, rolename, permission } = params
      const chain = await editRole()
        .params({
          roleid,
          rolename
        })
        .onSuccess(payload => {
          dispatch('fetchGetRoleDatas2')
          dispatch('fetchUpdatePermissionDatas', { roleid, permission })
          commit('setRoleDrawerVisible', false)
        })
        .onComplete(() => {
          commit('setRolemanageLoading', false)
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    }
  }
}
